<template>
  <v-dialog
    v-model="showDialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isCreateType && canCreateTag"
        v-bind="attrs"
        v-on="on"
        color="info"
        :class="$vuetify.breakpoint.xsOnly ? '' : 'px-7 mr-4'"
        @click="showDialog = true"
        style="text-transform: none;"
      >
        <v-icon left>mdi-plus-box</v-icon>
        {{ $t("createTag") }}
      </v-btn>

      <v-btn
        v-else-if="!isCreateType && (canEditTag || canRemoveTag)"
        outlined
        class="px-7"
        :class="$vuetify.breakpoint.xsOnly ? 'mt-4' : 'mr-4'"
        @click="showDialog = true"
        style="text-transform: none;"
      >
        <v-icon left>mdi-cog-outline</v-icon>
        {{ $t("manageTags") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-toolbar-title>{{
          isCreateType
          ? $t("createNewTag")
          : $t("manageTags")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text :style="{ height: isCreateType ? '' : '428px' }">
        <div v-if="!isCreateType">
          <div
            class="text-subtitle-1 pa-0 mt-6 mb-2"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >
            {{ $t("selectTag") }}
          </div>

          <v-autocomplete
            v-model="selectedTag"
            :items="listTags"
            :loading="isLoading"
            :placeholder="$t('toSelect')"
            item-text="title"
            item-value="color"
            return-object
            outlined
            clearable
            dense
            hide-details
            autofocus
            :disabled="isLoading"
            :no-data-text="$t('noTagFound')"
          >
            <template v-slot:item="{ item }">
              <div
                class="rounded-pill py-1 px-3 my-2"
                style="width: fit-content;"
                :style="{
                  'background-color': item.color + '80',
                  'color': 'white',
                  'border': '2px solid ' + item.color,
                }"
              >
                {{ item.title }}
              </div>
            </template>
            <template v-slot:selection="{ item }">
              <div
                class="rounded-pill py-1 px-3"
                style="width: fit-content;"
                :style="{
                  'background-color': item.color + '80',
                  'color': 'white',
                  'border': '2px solid ' + item.color,
                }"
              >
                {{ item.title }}
              </div>
            </template>
          </v-autocomplete>
        </div>

        <div
          v-if="isCreateType || (!isCreateType && selectedTag && canEditTag)"
        >
          <div
            class="text-subtitle-1 pa-0 mt-6 mb-2"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >
            {{ $t("title") }}
          </div>

          <v-text-field
            v-model="titleTag"
            ref="titleTagRef"
            :rules="rulesTag"
            :placeholder="$t('insertTitle')"
            required
            clearable
            outlined
            dense
            autofocus
            type="text"
            :counter="12"
            :maxlength="12"
            :disabled="isLoading"
          ></v-text-field>

          <div
            class="text-subtitle-1 pa-0 mb-2"
            :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
          >
            {{ $t("selectColor") }}
          </div>
          <div
            class="pa-4"
            style="
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              border-radius: 4px;
              gap: 16px;
              width: fit-content;
            "
            :style="{
              border: `1px solid ${$vuetify.theme.dark ? 'white' : 'black'}`,
            }"
          >
            <div
              v-for="(color, index) in colorsTag"
              :key="index"
              :style="{
                'background-color': color,
                margin: selectedColor == color ? '' : '3px',
                width:  selectedColor == color ? '33px' : '30px',
                height:  selectedColor == color ? '33px' : '30px',
                'border-radius': '100%',
                cursor: 'pointer',
                border: selectedColor == color
                  ? `3px solid ${$vuetify.theme.dark ? 'white' : 'black'}`
                  : '',
                'justify-self': 'center',
                'align-self': 'center'
              }"
              @click="updateSelectedColor(color)"
            ></div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions :class="isCreateType ? 'px-6 pb-6' : 'pa-6'">
        <div
          v-if="!isCreateType && selectedTag && canRemoveTag && canEditTag"
          class="d-flex align-self-end"
        >
          <DialogConfirmRemoveTags
            :isOutlinedOpenBtn="true"
            :isOpenDialogIconMobile="true"
            :selectedTags="[selectedTag]"
            @emitUpdateListTags="emitUpdateListTags"
          />
        </div>

        <v-spacer></v-spacer>

        <div
          :class="!isCreateType && $vuetify.breakpoint.width < 358
            ? 'd-flex flex-column align-end'
            : 'd-flex'"
        >
          <v-btn
            :class="$vuetify.breakpoint.width < 358
              ? 'px-6'
              : 'px-4'"
            outlined
            :disabled="isLoading"
            @click="closeDialog"
            style="text-transform: none;"
          >
            {{ $t("toCancel") }}
          </v-btn>

          <div
            v-if="!isCreateType && !canEditTag"
            class="ml-4"
          >
            <DialogConfirmRemoveTags
              :selectedTags="selectedTag ? [selectedTag] : []"
              @emitUpdateListTags="emitUpdateListTags"
            />
          </div>

          <v-btn
            v-else
            class="px-7"
            :class="!isCreateType && $vuetify.breakpoint.width < 358
              ? 'mt-4'
              : 'ml-4'"
            color="primary"
            :loading="isLoading"
            v-on:click.prevent="isCreateType ? createNewTag() : editTag()"
            type="submit"
            :disabled="
              isDisabledSaveBtn
              || (
                !isCreateType
                && selectedTag
                && titleTag === selectedTag.title
                && selectedColor === selectedTag.color
              )
            "
          >
            {{
              isCreateType
              ? $t("create")
              : $t("toSave")
            }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate";
import DialogConfirmRemoveTags from "../DialogConfirmRemoveTags/index.vue";

export default {
  name: "CreateOrManageTag",

  props: ["isCreateType", "listTags"],

  components: { DialogConfirmRemoveTags },

  data: () => ({
    // BOTH
    showDialog: false,
    titleTag: "",
    rulesTag: [validate.min3Characters, validate.max12Characters],
    selectedColor: "#F8620D",
    isDisabledSaveBtn: true,
    isLoading: false,
    colorsTag: [
      "#F8620D",
      "#FF0000",
      "#016A32",
      "#76B13D",
      "#E4679D",
      "#DA0063",
      "#12CDD4",
      "#7530D2",
      "#D1A813",
      "#820897",
      "#050EEB",
      "#666666",
    ],
    // MANAGE
    selectedTag: "",
  }),

  watch: {
    showDialog(showDialog) {
      if (showDialog) {
        this.selectedColor = "#F8620D";
        this.selectedTag = "";
        this.titleTag = "";
        this.isDisabledSaveBtn = true;
      }
    },
    selectedTag(currentSelectedTag) {
      if (currentSelectedTag) {
        this.selectedColor = currentSelectedTag.color;
        this.titleTag = currentSelectedTag.title;
        this.isDisabledSaveBtn = false;
      } else {
        this.selectedColor = "#F8620D";
        this.titleTag = "";
        this.isDisabledSaveBtn = true;
      }
    },
    titleTag(titleTag) {
      if (
        !titleTag
        || (titleTag && (titleTag.length < 3 || titleTag.length > 12))
      ) {
        this.isDisabledSaveBtn = true;
      } else {
        this.isDisabledSaveBtn = false;
      }
    },
  },

  computed: {
    canCreateTag() {
      return this.$permission("141");
    },
    canEditTag() {
      return this.$permission("145");
    },
    canRemoveTag() {
      return this.$permission("142");
    },
  },

  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    updateSelectedColor(currentSelectedColor) {
      this.selectedColor = currentSelectedColor;
    },
    createNewTag() {
      if (!this.$refs.titleTagRef.validate()) {
        this.isDisabledSaveBtn = true;

        return;
      }

      this.isLoading = true;
      this.isDisabledSaveBtn = true;

      this.$axios.post(`${this.$prefix()}/tags/addTag`, this.$formdata({
        tag_title: this.titleTag,
        tag_color: this.selectedColor,
      }))
      .then((res) => {
        this.$store.commit("setFeedbackSnack", {
          msg: res.data.messages,
          color: "success",
        });

        this.emitUpdateListTags();
      })
      .finally(() => {
        this.isLoading = false;
        this.isDisabledSaveBtn = false;
      });
    },
    editTag() {
      if (!this.$refs.titleTagRef.validate()) {
        this.isDisabledSaveBtn = true;

        return;
      }

      this.isLoading = true;
      this.isDisabledSaveBtn = true;

      this.$axios.post(`${this.$prefix()}/tags/editTag`, this.$formdata({
        tag_id: this.selectedTag.id,
        tag_title: this.titleTag,
        tag_color: this.selectedColor,
      }))
      .then((res) => {
        this.$store.commit("setFeedbackSnack", {
          msg: res.data.messages,
          color: "success",
        });

        this.emitUpdateListTags();
      })
      .finally(() => {
        this.isLoading = false;
        this.isDisabledSaveBtn = false;
      });
    },
    emitUpdateListTags() {
      this.$emit("updateListTags");

      this.closeDialog();
    },
  },
}
</script>